import { Blockchain } from "@rarible/api-client"
import { moonbeam } from "viem/chains"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

export const moonbeamConfig: StaticEthereumBlockchainConfig = {
  name: "Moonbeam",
  icon: "/images/blockchains/moonbeam.svg",
  isEvm: true,
  testnet: false,
  isTestnet: false,
  feesVersion: "v3",
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  unionApi: "https://api.rarible.org",
  basePath: "https://moonbeam-api.rarible.org",
  chainId: moonbeam.id,
  blockchain: Blockchain.MOONBEAM,
  chainName: moonbeam.name,
  exchange: {
    v2: "0x30fc6eed1d302F5f5C4a8aa58047d1a730b3Cc91",
    wrapper: "0xEA26e060cCc11C840e6107cfca0B41c45Ce6a5a2",
  },
  blockExplorers: [
    {
      url: "https://moonscan.io",
      icon: "/images/scanner.svg",
      adress: "https://moonscan.io/address/${adrress}",
    },
  ],
  rpcUrls: [],
  privateRpcNodeSlug: "moonbeam-node",
  transferProxies: {
    nft: "0x57559104c0e4fbc578fF4251b63eA0903d7CAe32",
    erc721Lazy: "0x13b05523634ABb96E6017Da71b7698CAecDf50b2",
    erc20: "0x4217a346C8b48731641327b65bb6F6d3243d64e2",
  },
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId("MOONBEAM:0x0000000000000000000000000000000000000000"),
    symbol: "GLMR",
    name: "Moonbeam",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId("MOONBEAM:0xacc15dc74880c9944775448304b263d191c6077f"),
    symbol: "WGLMR",
    name: "Wrapped Moonbeam",
    decimals: 18,
  },
  addFundsLink: "https://app.stellaswap.com/exchange/cross-chain-swap",
  hasStabilityProtocol: true,
  viem: moonbeam,
}

export const getMoonbeamConfig = (): StaticEthereumBlockchainConfig =>
  moonbeamConfig
